import type { FC } from 'react';

interface OrderTypeBadgeProps {
    type: string;
    className?: string;
}

const OrderTypeBadge: FC<OrderTypeBadgeProps> = ({ type, className = '' }) => (
    <span className={`text-xs px-2 py-0.5 rounded-md border capitalize ${
        type === 'ecom'
            ? 'bg-pink-50 text-[#ee2b74] border-pink-100'
            : 'bg-[#f0f7e6] text-[#5a7f28] border-[#c5e08a]'
    } ${className}`}>
        {type}
    </span>
);

export default OrderTypeBadge;